webpackJsonp([324],{

/***/ 1031:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  head: { "title": "VUX V2.2.1Rc.2 released | VUX - Vue.js Mobile UI Component Framework", "ignoreSuffixChar": "|" }
});

/***/ }),

/***/ 1846:
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(67)(
  /* script */
  __webpack_require__(1031),
  /* template */
  __webpack_require__(2457),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/home/runner/work/vux/vux/docs/node_modules/v-markdown-loader/_cache/v2.2.1-rc.2-91.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] v2.2.1-rc.2-91.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-e1db5724", Component.options)
  } else {
    hotAPI.reload("data-v-e1db5724", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),

/***/ 2457:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("VUX V2.2.1Rc.2 released")]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/badge.html"
    }
  }, [_vm._v("Badge")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] Fix className:vux-badge-single not work for number #1223")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/inline-calendar.html"
    }
  }, [_vm._v("InlineCalendar")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[enhance] Now next month's day can be clicked and will automatically switch to next month's view #1192")]), _vm._v(" "), _c('li', [_vm._v("[fix] fix start-date and end-date not reactive #1219")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/swiper.html"
    }
  }, [_vm._v("Swiper")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[enhance] Use document width as swiper width if initial width is 0 #1188")]), _vm._v(" "), _c('li', [_vm._v("[fix] Fix initial index > 0 not works")])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-e1db5724", module.exports)
  }
}

/***/ }),

/***/ 509:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1846);

/***/ })

});


// WEBPACK FOOTER //
// 324.79d5a95e.js